import * as t from "io-ts";

export const codec = t.type({
    mean_days: t.union([t.number, t.null]),
    sample_size: t.number,
});

export type T = t.TypeOf<typeof codec>;

export const newDefault = (): T => ({
    mean_days: null,
    sample_size: 0,
});

export const isPublishable = (
    statistic: T,
    guards: { minimumSampleSize: number; saneBand: { min: number; max: number } },
): boolean =>
    statistic.mean_days !== null
    && statistic.sample_size >= guards.minimumSampleSize
    && statistic.mean_days >= guards.saneBand.min
    && statistic.mean_days <= guards.saneBand.max;

export const displayDays = (statistic: T): number =>
    Math.round(statistic.mean_days ?? 0);
